import React from 'react';
import { GeoFirestore } from '../../firebase';
import { useRentalsByLocationQuery } from '../../hooks/useRentalsByLocationQuery'; 
import { Helmet } from 'react-helmet';
import { Message } from 'semantic-ui-react';
import { useTheme } from '../../features/dark-mode/ThemeContext';

//components
import Loader from '../../components/loader/SimpleLoader';
import CollectionContainer from '../../components/collection-container/CollectionContainer';


const RentalByLocationPage = () => {

 const theme = useTheme(); 
 const { items, loading } = useRentalsByLocationQuery(GeoFirestore.collection('rentals'), { radius: 200 })

  if (loading) return <Loader text='...Retrieving your location' />;

  return (
    <>
      <Helmet>
        <title> Rentals closest to you </title>
        <meta
          name='description'
          content='This page contains rentals closest to user location'
        />
      </Helmet>

      {items.length > 0 ? (
        <CollectionContainer
          withRating
          columns={4}
          rentals={items}
          viewButton
          header='Rentals closest to you'
          path='/rentals'
        />
      ) : (
        <Message>
          <p style={{ color: theme?.dark ? 'black' : '' }}> Please enable geolocation by clicking on the lock icon in the address bar next to the website !</p>
        </Message>
      )}
    </>
  );
};

export default RentalByLocationPage;
